import * as React from 'react';

const Alert = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M23.09 25.278L23.645 4.909H17.324L17.892 25.279H23.091L23.09 25.278ZM20.491 34.369C21.401 34.369 22.194 34.038 22.871 33.375C23.548 32.712 23.891 31.907 23.901 30.96C23.891 30.032 23.548 29.237 22.871 28.574C22.194 27.911 21.401 27.58 20.491 27.58C19.554 27.58 18.749 27.911 18.077 28.574C17.404 29.237 17.073 30.032 17.082 30.96C17.072 31.907 17.404 32.712 18.077 33.375C18.749 34.038 19.554 34.369 20.491 34.369Z" fill="currentColor"/>
  </svg>
);

export default Alert;
